import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NotFound.css';

export default function NotFound() {
  const { t } = useTranslation('common');

  return (
    <main className="rds-empty-page">
      <section className="rds-empty rds-empty--framed">
        <div className="rds-empty-header">
          <span className="rds-empty-media rds-empty-media--code" aria-hidden="true">404</span>
          <h1 className="rds-empty-title">{t('notFound.title')}</h1>
          <p className="rds-empty-description">{t('notFound.description')}</p>
        </div>
        <div className="rds-empty-content">
          <Link
            to="/"
            className="rds-button rds-focusable rds-button--neutral rds-button--md"
          >
            {t('notFound.goToApp')}
          </Link>
        </div>
      </section>
    </main>
  );
}
